import React from 'react';

const AuthUserContext = React.createContext(null);
const CompanyUserContext = React.createContext(null);

export default AuthUserContext;
export { CompanyUserContext };